export enum TimelineVehicleStatesMessages {
  statesTitle = "timelineVehicleStates.statesTitle",
  manometer = "timelineVehicleStates.manometer",
  blockedVehicle = "timelineVehicleStates.blockedVehicle",
  blockingDate = "timelineVehicleStates.blockingDate",
  postUnloadIdleTime = "timelineVehicleStates.postUnloadIdleTime"
}

export type TranslationTimelineVehicleStatesMessages = {
  [key in TimelineVehicleStatesMessages]: string;
}
